// extracted by mini-css-extract-plugin
export var chevron = "_2y-2";
export var chevronCollapsed = "_2y-3";
export var collapsibleHeader = "_2y-1";
export var container = "_2y-0";